import React, { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

export default function WysiwygEditor({ reset, onChange, editorValue }) {
  const [editorState, setEditorState] = useState();

  useEffect(() => {
    let contentBlock;
    if (editorValue) contentBlock = htmlToDraft(editorValue);
    else contentBlock = htmlToDraft("");

    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
    setEditorState(EditorState.createWithContent(contentState));
  }, [editorValue]);

  useEffect(() => {
    setEditorState(EditorState.createEmpty());
  }, [reset]);

  // Function to remove background styles
  const sanitizeHtml = (html) => {
    return html.replace(/background[^;]+;?/g, ""); // Removes inline background styles
  };

  const handleChange = (data) => {
    setEditorState(data);
    const rawHtml = draftToHtml(convertToRaw(editorState?.getCurrentContent()));
    const sanitizedHtml = sanitizeHtml(rawHtml); // Apply sanitization

    onChange && onChange(sanitizedHtml);
  };

  return <Editor editorState={editorState} onEditorStateChange={handleChange} placeholder="Açıklama giriniz" />;
}
